import axios from "axios";
import {
  STATUS_HISTORY_LOG,
  get_headers,
} from "@/utils/constants/constants.js";

export default {
  name: "LeadsLogs",

  data: () => ({
      steps: [
        "New Lead",
        "Qualified Lead",
        "Negotiation",
        "Approval",
        "Closed",
      ],
      current_step: 0,
      time_line_entries: [],
  }),

  mounted() {
    this.fetch_history();
  },

  methods: {
    async fetch_history() {
      const lead_id = this.$route.query.lead_id;
      if (!lead_id) {
        this.show.error("No lead_id provided.");
        return;
      }

      axios
        .get(STATUS_HISTORY_LOG, {
          headers: get_headers(),
          params: { lead_id: lead_id },
        })
        .then((response) => {
          if (response.data.status !== "success") {
            this.show.error(`API returned error: ${response.data.message}`);
            return;
          }

          const raw_entries = response.data.data;

          const parsed = raw_entries.map((e) => {
            const dt = new Date(e.changed_at);
            const options_date = {
              year: "numeric",
              month: "long",
              day: "numeric",
            };
            const date_string = dt.toLocaleDateString("en-US", options_date);
            const options_time = { hour: "numeric", minute: "2-digit" };
            const time_string = dt.toLocaleTimeString("en-US", options_time);

            const title = `Status changed from “${e.from_sub}” to “${e.to_sub}”`;
            const actor = e.by || "Unknown";
            const auto_text = e.is_automatic ? "(Auto)" : "(Manual)";
            const message = `${auto_text} by ${actor}`;

            return {
              date: date_string,
              time: time_string,
              title,
              message,
            };
          });

          parsed.sort((a, b) => {
            const date_a = new Date(a.date + " " + a.time);
            const date_b = new Date(b.date + " " + b.time);
            return date_b - date_a;
          });

          this.time_line_entries = parsed;
          this.update_current_step(raw_entries);
        })
        .catch((error) => {
          this.show.error(`Error fetching status history: ${error.message}`);
        });
    },

    update_current_step(raw_entries) {
      if (!Array.isArray(raw_entries) || raw_entries.length === 0) {
        this.current_step = 0;
        return;
      }

      const latest = raw_entries.reduce((prev, curr) =>
        new Date(curr.changed_at) > new Date(prev.changed_at) ? curr : prev
      );
      const idx = this.steps.findIndex((step_name) => step_name === latest.to_sub);
      this.current_step = idx >= 0 ? idx : 0;
    },
  },
};